import './motion-switch.js';
import './carousel.js';
import './main.js';